import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/icons/iconfont.css';
import 'v-org-tree/dist/v-org-tree.css';
// import TreeTable from 'tree-table-vue';
import VOrgTree from 'v-org-tree';
// import 'view-design/dist/styles/iview.css';

import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
Vue.use(VueDPlayer)

import './permission' // permission control

import { parseTime } from "@/utils/common";


import VueResource from 'vue-resource'
import moment from 'moment'
import axios from 'axios'

import "./assets/style/index.css"
// 图片展示
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
//上传文件图标
import '@/assets/svgIcon'

import { getDicts } from "./request/dict/data";

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/common.scss' // common css

Vue.prototype.$EventBus = new Vue()
// 上传文件
import uploader from 'vue-simple-uploader'
Vue.use(uploader)
import global from './utils/global.js'
Vue.prototype.$global = global
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  en: {
    message: 'hello',
    ...locale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
}
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
/**
 * 全局引入jquery
 */
import $ from 'jquery'
window.$ = $;
window.jQuery = $;

//eventbus
import { EventBus } from "@/utils/event-bus"
Vue.prototype.meibus = EventBus

//base64
import Base64 from "./utils/base64";
Vue.prototype.$Base64 = Base64;


import directive from './directive' //directive
// 全局方法挂载
Vue.prototype.getDicts = getDicts

// 时间处理
Vue.use(require('moment'));
Vue.prototype.moment = moment
Vue.filter('dateYMDHMSFormat', function (dateStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dateStr).format(pattern);
})
//分页
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgWarning = function (msg) {
  this.$message({ showClose: true, message: msg, type: "warning" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}


// 全局方法挂载
Vue.prototype.parseTime = parseTime

Vue.prototype.$axios=axios
Vue.use(ElementUI, { locale });
Vue.use(VueResource);
// Vue.use(TreeTable);
Vue.use(VOrgTree);
Vue.use(directive)
Vue.use(Viewer, {
  defaultOptions: {
      zIndex: 9999
  }
})

Vue.prototype.Enumerable = require('linq');
Vue.config.productionTip = false;

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    // 用路由的replace方法，
    // 并没有相当于F5刷新页面，
    // 失败的js文件并没有从新请求，
    // 会导致一直尝试replace页面导致死循环，
    // 而用 location.reload 方法，相当于触发F5刷新页面，
    // 虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，
    // 从而曲线救国解决该问题
    window.location.reload();
    // router.replace(targetPath);
  } else {

  }
});

/*
* 全局注册防多次点击，重复提交
* */
import preventReClick from '@/utils/preventReClick.js'
Vue.prototype.preventReClick = preventReClick;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
